import React from "react";
import Autosuggest from "react-autosuggest";

export default function ({ language, InputField, tools }) {
  class AddressFieldLeazardCloud extends React.Component {
    constructor() {
      super();
      this.state = {
        suggestions: [],
        value: "",
        address: {},
        zipCodeInfo: {},
        strict: true,
        houseNumber: "",
        houseNumberTouched: false,
        postcodeTouched: false,
      };
      this.houseNumberRef = React.createRef();
    }

    componentDidUpdate = () => {
      this.setGlobalState();
    };

    render() {
      const { config } = this.props.field;
      const { value, suggestions } = this.state;
      const defaultPlaceholder = language.address_no_number_placeholder;
      const defaultLabel = language["address-label"];
      const inputProps = {
        placeholder: defaultPlaceholder,
        value,
        onChange: this.onAddressChange,
        errors: this.props.errors
      };
      return (
        <div>
          <div className="lz-input-wrapper">
            <div className="lz-table lz-table-top">
              <div className="lz-table-cell lz-cell-3-4">
                <label>{config.label || defaultLabel}</label>
                <Autosuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  renderInputComponent={this.styledInputComponent}
                  renderSuggestion={this.renderSuggestions}
                  getSuggestionValue={this.getSuggestionValue}
                  onSuggestionSelected={this.onSuggestionSelected}
                  focusInputOnSuggestionClick={false}
                  shouldRenderSuggestions={this.shouldRenderSuggestions}
                  inputProps={inputProps}
                />
              </div>
              {this.houseNumber()}
            </div>
          </div>
          {this.zipCode()}
        </div>
      );
    }

    houseNumber = () => {
      const { errorClass, errors } = this.props;
      return (
        <div className={"lz-table-cell lz-cell-1-4"}>
          <div style={{ paddingLeft: "5px" }}>
            <label>{language["address-street-number-label"]}</label>
            <div
              className={`lz-input ${
                this.state.houseNumberTouched ? errorClass : ""
              }`}
            >
              <div className="lz-checkmark">
                <i className="fa fa-check" />
              </div>
              <input
                ref={this.houseNumberRef}
                onBlur={() =>
                  this.setState(
                    (state) => ({ ...state, houseNumberTouched: true }),
                    this.setGlobalState()
                  )
                }
                placeholder={language["address-street-number-placeholder"]}
                type="tel"
                value={this.state.houseNumber}
                onChange={(e) => this.onHouseNumberChange(e)}
              />
              <span className="lz-input-bar" />
            </div>
            {this.getErrorStatus("houseNumber") && errors}
          </div>
        </div>
      );
    };

    zipCode = () => {
      const { errorClass, errors } = this.props;

      return (
        <div>
          <div className="lz-input-wrapper">
            <label
            // htmlFor={tools.uniqueId(id)}
            >
              {language["zip-label"]}
              {/* {config.label} */}
            </label>
            <div className="lz-table lz-table-middle">
              <div className="lz-table-cell lz-cell-1-2">
                <div
                  className={`lz-input ${
                    this.state.houseNumberTouched ? errorClass : ""
                  }`}
                >
                  {/* <div className={this.spinnerClass()}>
                    <i className="fa fa-spinner fa-spin" />
                  </div> */}

                  <div className="lz-checkmark">
                    <i className="fa fa-check" />
                  </div>

                  <input
                    type="number"
                    ref={(input) => (this.zipInput = input)}
                    onChange={(e) => this.onZipChange(e)}
                    value={this.state.zipCodeInfo?.postcode || ""}
                    placeholder={language["zip_placeholder"]}
                  />
                  <span className="lz-input-bar" />
                </div>
                {this.getErrorStatus("postcode") && errors}
              </div>
              <div className="lz-table-cell lz-cell-1-2">
                <div
                  className={
                    "lz-areacode" +
                    (this.state.zipCodeInfo?.postarea ? " is-visible" : "")
                  }
                >
                  <span> {this.state.zipCodeInfo?.postarea} </span>
                </div>
                ;{/* {this.state.address?.postarea} */}
              </div>
            </div>
          </div>
          {/* {this.alertInfoBox()} */}
        </div>
      );
    };

    styledInputComponent = (inputProps) => {
      const { errorClass, errors } = this.props;
      return (
        <>
          <div
            className={`lz-input ${
              this.state.houseNumberTouched ? errorClass : ""
            }`}
          >
            <div className="lz-checkmark">
              <i className="fa fa-check" />
            </div>
            <input {...inputProps} autoComplete="off" />
            <span className="lz-input-bar" />
          </div>
          {this.getErrorStatus("address") && errors}
        </>
      );
    };
    onHouseNumberChange = (e) => {
      e.persist();
      this.setState((state) => ({
        ...state,
        houseNumber: e.target.value,
      }));
    };

    onZipChange = async (e) => {
      e.persist();

      this.setState((state) => ({
        ...state,
        zipCodeInfo: {
          ...state.zipCodeInfo,
          postcode: e.target.value,
        },
      }));

      const zipCodeInfo = await this.fetchCityFromZip("SE", e.target.value);

      if (e.target.value.toString().length >= 5) {
        this.setState(
          (state) => ({
            ...state,
            zipCodeInfo: {
              ...state.zipCodeInfo,
              postarea: zipCodeInfo[0]?.postarea,
            },
          }),
          this.setGlobalState()
        );
      }
    };
    onAddressChange = (event, { newValue, method }) => {
      this.setState((state) => ({
        ...state,
        value: newValue,
      }));
    };
    shouldRenderSuggestions = (value, reason) => {
      return value.trim().length > 3;
    };
    getSuggestionValue = (suggestion) => {
      this.setState((state) => ({
        ...state,
        address: suggestion,
        zipCodeInfo: {
          postcode: suggestion.postcode,
          postarea: suggestion.postarea,
        },
      }));
      return `${suggestion?.street}`;
    };
    getSuggestions = (value) => {
      return this.state.suggestions.length <= 0
        ? []
        : this.state.suggestions.map((e) => e.street);
    };
    renderSuggestions = (suggestion) => (
      <div>{`${suggestion?.street}, ${suggestion?.postcode} ${suggestion?.postarea}`}</div>
    );
    onSuggestionsFetchRequested = async ({ value }) => {
      const newSuggestions = await this.fetchSuggestionFromLeazardCloud(
        "SE",
        value
      );
      this.setState((state) => ({
        ...state,
        suggestions: newSuggestions,
      }));
    };
    onSuggestionsClearRequested = () => {
      this.setState({
        suggestions: [],
      });
    };
    onSuggestionSelected = (event, { suggestion, suggestionValue }) => {
      try {
        this.setState((state) => ({
          ...state,
          value: suggestionValue,
        }));
        this.houseNumberRef.current.focus();
      } catch (e) {
        console.log(e);
      }
    };
    fetchSuggestionFromLeazardCloud = async (countryCode, query) => {
      const baseURL = "https://leazardcloud.com/production/search/streets?";
      const countryCodeString = `country=${countryCode}`;
      const queryString = `&query=${query.replace(" ", "%20")}`;

      try {
        const res = await fetch(baseURL + countryCodeString + queryString, {
          headers: {
            "content-type": "application/json",
          },
        });
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        } else {
          const data = await res.json();
          return data.data;
        }
      } catch (e) {
        console.log(e);
      }
    };

    fetchCityFromZip = async (countryCode, query) => {
      const baseURL = "https://leazardcloud.com/production/search/postcodes?";
      const countryCodeString = `country=${countryCode}`;
      const queryString = `&query=${query.trim()}`;

      if (query.toString().length >= 5) {
        try {
          const res = await fetch(baseURL + countryCodeString + queryString, {
            headers: {
              "content-type": "application/json",
            },
          });
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          } else {
            const data = await res.json();
            return data.data;
          }
        } catch (e) {
          console.log(e);
        }
      }
    };

    setGlobalState = () => {
      this.props.field.state.value = this.state.value;
      this.props.field.state.houseNumber = this.state.houseNumber;
      this.props.field.state.postcode = this.state.zipCodeInfo?.postcode;
      this.props.field.state.houseNumberTouched = this.state.houseNumberTouched;
      this.props.field.state.postcodeTouched = this.state.postcodeTouched;
    };

    getErrorStatus = (field) => {
      const { errors } = this.props.field.state;
      switch (field) {
        case "address":
          return (
            errors?.includes(language["address-missing"]) ||
            errors?.includes(language["error-mandatory"])
          );
        case "houseNumber":
          return (
            errors?.includes(language["address-missing-street-number"]) ||
            errors?.includes(language["error-mandatory"])
          );
        case "postcode":
          return (
            errors?.includes(language["zip-error"]) ||
            errors?.includes(language["error-mandatory"])
          );
        default:
          break;
      }
    };
  }

  return {
    html: AddressFieldLeazardCloud,
    validators: [
      function (state) {
        const { value, houseNumber, postcode } = state;
        if (state.houseNumberTouched) {
          if (moreThanOneError([value, houseNumber, postcode]))
          return language["error-mandatory"];
          if (!value) return language["address-missing"];
          if (!houseNumber) return language["address-missing-street-number"];
          if (!postcode) return language["zip-error"];
          return false;
        }
        if (!houseNumber) return language["address-missing-street-number"];
      },
    ],
  };
}

const moreThanOneError = (arr) => {
  return arr.map((x) => !x).filter(Boolean).length >= 2;
};
